// Utilerias compartidas de las graficas de efectividad (tabla a_graficas_efectividad,
// que llena cada madrugada el cron api.pmm.com.mx/tareas_crontab/indicadores.php).
import PropTypes from "prop-types";

// Metricas de un dia (global, por sucursal o por fecha) tal como las entrega el API:
// porcentajes y conteos numericos, null = sin actividad ese dia.
export const metricasPropTypes = {
  ead: PropTypes.number,
  ead_atiempo: PropTypes.number,
  ead_total: PropTypes.number,
  rad: PropTypes.number,
  rec_realizadas: PropTypes.number,
  rec_total: PropTypes.number
};

// 'YYYY-MM-DD' -> 'DD/MM/YYYY'
export const formatearFecha = (iso) => {
  if (!iso || typeof iso !== "string" || iso.length < 10) {
    return iso || "";
  }
  return iso.substr(8, 2) + "/" + iso.substr(5, 2) + "/" + iso.substr(0, 4);
};

// null = sin actividad ese dia (distinto de un 0 % real)
export const porcentaje = (valor, decimales = 1) =>
  valor === null || valor === undefined ? "sin datos" : Number(valor).toFixed(decimales) + " %";

// Mismos colores que la grafica "Indicadores EAD - Recolecciones" del dashboard.
export const COLOR_EAD = "#7cb5ec";
export const COLOR_RAD = "#434348";
